/**
 * ФИО для шапки админки: фамилия + имя (отчества в модели нет).
 */
export function formatUserFio(user) {
  if (!user) return '';
  const lastname = String(
    user.lastname || user.Lastname || user.lastName || user.LastName || '',
  ).trim();
  const name = String(user.name || user.Name || '').trim();
  return [lastname, name].filter(Boolean).join(' ');
}
